import React, { useEffect, useState, useRef, useCallback, useMemo, memo } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

  const COLUMN_LABELS = {
  'Commande fournisseur'      : 'Cmde frn',
  'Nom fournisseur'           : 'Fournisseur',
  'Date de réception'         : 'Réception',
  'Quantité cmde frn allouée' : 'Qté frn allouée',
  'Numero de commande'        : 'Num Cmde',
};





const COLUMN_WIDTHS = {
  'Date de livraison prevue'  : 110,
  Horizon                     : 75,
  Item                        : 110,
  Description                 : 200,
  'Numero de commande'        : 50,
  'N° ligne'                  : 60,
  Client                      : 110,
  'Commande fournisseur'      : 80,
  'Nom fournisseur'           : 120,
  'Date de réception'         : 1,
  'Quantité cmde frn allouée' : 90,
  'RAL'                         : 60,
  Stock                       : 60,
  Rupture                     : 60,
  Commentaires                : 250,
  Pilote                      : 100,
};

const INT_COLS = ['RAL', 'Stock', 'Rupture'];
const HIDDEN   = ['_index', 'Service'];


const ROW_COLORS = {
  'row-green'  : '#c8e6c9',
  'row-red'    : '#ffcdd2',
  'row-yellow' : '#fff9c4',
};

const TOOLBAR_CONFIG = {
  btnSave      : { width: '170px', marginLeft: '0px',  marginRight: '8px',  fontSize: '13px', show: true },
  filterItem   : { labelWidth: '30px', inputWidth: '110px', marginLeft: '8px', marginRight: '0px', fontSize: '13px', show: true },
  filterClient : { labelWidth: '40px', inputWidth: '110px', marginLeft: '8px', marginRight: '0px', fontSize: '13px', show: true },
  filterCommande: { labelWidth: '85px', inputWidth: '110px', marginLeft: '8px', marginRight: '0px', fontSize: '13px', show: true },
  checkbox     : { marginLeft: '12px', marginRight: '0px', fontSize: '13px', show: true },
  legendes     : { marginLeft: '12px', marginRight: '0px', fontSize: '12px', gapEntreItems: '12px', show: true },
  btnExcel     : { width: '140px', marginLeft: '12px', marginRight: '0px', fontSize: '13px', show: true },
};

const formatDateFR = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d)) return value;
  return d.toLocaleDateString('fr-FR');
};

const cleanText = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const s = String(value).trim();
  if (['nan', 'undefined', 'null'].includes(s.toLowerCase())) return '';
  return s;
};

// APRÈS — à mettre à la place
const parseDate = (value) => {
  if (!value) return null;
  if (typeof value === 'string' && value.includes('/')) {
    const [day, month, year] = value.split('/');
    return new Date(`${year}-${month}-${day}`);
  }
  const d = new Date(value);
  return isNaN(d) ? null : d;
};

const getRowClass = (row) => {
  const rupture = Number(row.Rupture);
  if (rupture <= 0) return 'row-green';
  const dateReception = parseDate(row['Date de réception']);
  const dateLivraison = parseDate(row['Date de livraison prevue']);
  if (dateReception && dateLivraison) {
    if (dateReception > dateLivraison) return 'row-red';
    if (dateReception < dateLivraison) return 'row-yellow';
  }
  return 'row-red';
};

// ── Ligne ──────────────────────────────────────────────────────────────────
const AnimationRow = memo(({ row, columns, utilisateurs, editsRef }) => {
  const rupture = Number(row.Rupture);
  const bg      = ROW_COLORS[getRowClass(row)] || '#ffffff';

  return (
    <tr style={{ borderBottom: '1px solid #e9ecef' }}>
      {columns.map((col) => {
        const w = COLUMN_WIDTHS[col] || 100;

        if (col === 'Pilote') return (
          <td key={col} style={{ width: w, minWidth: w, backgroundColor: bg, padding: '6px 8px', verticalAlign: 'middle' }}>
            {rupture === 0 ? '' : (
              <select
                defaultValue={row.Pilote || ''}
                onChange={(e) => { editsRef.current[row._index] = { ...editsRef.current[row._index], Pilote: e.target.value }; }}
                style={{ width: '100%', fontSize: '12px', border: '1px solid #ddd', borderRadius: '4px', padding: '2px 4px' }}
              >
                <option value=""></option>
                {utilisateurs.map((u, i) => (
                  <option key={i} value={u.Prenom}>{u.Prenom}</option>
                ))}
              </select>
            )}
          </td>
        );

        if (col === 'Commentaires') return (
          <td key={col} style={{ width: w, minWidth: w, backgroundColor: bg, verticalAlign: 'top', padding: '6px 8px' }}>
            {rupture === 0 ? '' : (
              <textarea
                defaultValue={row.Commentaires || ''}
                onChange={(e) => {
                  e.target.style.height = 'auto';
                  e.target.style.height = e.target.scrollHeight + 'px';
                  editsRef.current[row._index] = { ...editsRef.current[row._index], Commentaires: e.target.value };
                }}
                ref={(el) => { if (el) { el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; } }}
                style={{ width: '100%', resize: 'none', fontSize: '12px', boxSizing: 'border-box', overflow: 'hidden', minHeight: '32px', border: '1px solid #ddd', borderRadius: '4px', padding: '4px 6px', fontFamily: 'inherit' }}
              />
            )}
          </td>
        );

     if (col === 'Date de livraison prevue') return (
  <td key={col} style={{ width: w, minWidth: w, backgroundColor: bg, padding: '6px 8px', verticalAlign: 'middle', textAlign: 'center' }}>
    {formatDateFR(row[col])}
  </td>
);

if (col === 'Date de réception') return (
  <td key={col} style={{ width: w, minWidth: w, backgroundColor: bg, padding: '6px 8px', verticalAlign: 'middle', textAlign: 'center', whiteSpace: 'pre-line' }}>
    {(row[col] || '').split('\n').map(v => formatDateFR(v.trim())).join('\n')}
  </td>
);

        if (col === 'Quantité cmde frn allouée') {
          const vals = (row[col] || '').split('\n').map((v) => { const n = Number(v); return isNaN(n) ? v : Math.round(n); });
          return (
            <td key={col} style={{ width: w, minWidth: w, whiteSpace: 'pre-line', backgroundColor: bg, padding: '6px 8px', verticalAlign: 'middle', textAlign: 'center' }}>
              {vals.join('\n')}
            </td>
          );
        }

        return (
          <td key={col} style={{ width: w, minWidth: w, maxWidth: w, whiteSpace: 'normal', wordBreak: 'break-word', verticalAlign: 'middle',textAlign: 'center', backgroundColor: bg, padding: '6px 8px', fontSize: '12px' }}>
            {INT_COLS.includes(col) && row[col] != null ? Math.round(Number(row[col])) : row[col]}
          </td>
        );
      })}
    </tr>
  );
});

// ── Composant principal ───────────────────────────────────────────────────
const Animation = ({ posX = '100px', posY = '0px', width = '95%', height = 'auto' }) => {
  const [data, setData]                           = useState([]);
  const [utilisateurs, setUtilisateurs]           = useState([]);
  const [showOnlyManquants, setShowOnlyManquants] = useState(false);
  const [itemFilter, setItemFilter]               = useState('');
  const [commandeFilter, setCommandeFilter]       = useState('');
  const [clientFilter, setClientFilter]           = useState('');
  const [isSaving, setIsSaving]                   = useState(false);
  const [saveMsg, setSaveMsg]                     = useState('');

  const editsRef = useRef({});
  const dataRef  = useRef([]);
  useEffect(() => { dataRef.current = data; }, [data]);


    useEffect(() => {                                          // ← ajouter ici
    document.title = 'MYSSA – Animation';
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const jsonUtilisateurs = [
          { Prenom: 'ADV', Service: 'ADV' }, { Prenom: 'APPRO', Service: 'APPRO' },
        { Prenom: 'LOG', Service: 'LOG' },
          
        ];
        setUtilisateurs(jsonUtilisateurs);

        const resAnim = await fetch(`${API}/animation`);
        const rawAnim = await resAnim.json();
        const resCom  = await fetch(`${API}/base_commentaire_animation`);
        const rawCom  = await resCom.json();

        const merged = rawAnim.map(({ ID, Client_id, ...row }, index) => {
          const match = rawCom.find(
            (c) => String(c['Numero de commande']).trim() === String(row['Numero de commande']).trim() &&
                   String(c['N° ligne']).trim()           === String(row['N° ligne']).trim()
          );
          return { ...row, _index: index, Commentaires: cleanText(match?.Commentaires ?? row.Commentaires), Pilote: cleanText(match?.Pilote ?? row.Pilote) };
        });

        merged.sort((a, b) => {
          const dA = a['Date de livraison prevue'] ? new Date(a['Date de livraison prevue']) : new Date(0);
          const dB = b['Date de livraison prevue'] ? new Date(b['Date de livraison prevue']) : new Date(0);
          return dA - dB;
        });

        setData(merged);
        editsRef.current = {};
      } catch (err) {
        console.error('Erreur chargement Animation:', err);
      }
    };
    fetchData();
  }, []);

  const getRowWithEdits = (row) => ({ ...row, ...(editsRef.current[row._index] || {}) });

  const sauvegarderLigne = async (row) => {
    const r        = getRowWithEdits(row);
    if (Number(r.Rupture) === 0) return;
    const numCmde  = String(r['Numero de commande']).trim();
    const numLigne = String(r['N° ligne']).trim();
    const pilote   = cleanText(r.Pilote);
    const comment  = cleanText(r.Commentaires);

    let numeroTache = null;
    try {
      const res = await fetch(`${API}/base_commentaire_animation`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ numero_commande: numCmde, numero_ligne: numLigne, commentaire: comment, pilote, client: cleanText(r.Client), item: cleanText(r.Item), commande_fournisseur: cleanText(r['Commande fournisseur']), nom_fournisseur: cleanText(r['Nom fournisseur']), date_reception: r['Date de réception'] || null, quantite_cmde_frn_allouee: cleanText(r['Quantité cmde frn allouée']), rupture: Number(r.Rupture) }),
      });
      const json = await res.json();
      numeroTache = json.numero_tache;
    } catch (err) { console.error('❌ base_commentaire_animation :', err); return; }

    if (!pilote || !comment || !numeroTache) return;

    const dateLivraison = r['Date de livraison prevue']
      ? new Date(r['Date de livraison prevue']).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
      : '';
    const description = `Date de livraison prevue : ${dateLivraison} Item : ${cleanText(r.Item)} Commande client : ${numCmde} Ligne : ${numLigne}\nCommande fournisseur : ${cleanText(r['Commande fournisseur'])} Nom fournisseur : ${cleanText(r['Nom fournisseur'])} Date de réception : ${formatDateFR(r['Date de réception'])}`;

    try {
      await fetch(`${API}/taches`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ numero_tache: numeroTache, description, commentaires: comment, departement: pilote, de: 'Animation', source: 'animation' }),
      });
    } catch (err) { console.error('❌ taches :', err); }
  };

  const handleSaveAll = useCallback(async () => {
    setIsSaving(true); setSaveMsg('');
    const lignes = dataRef.current.filter((r) => Number(r.Rupture) !== 0);
    let ok = 0, ko = 0;
    for (const row of lignes) {
      const r = getRowWithEdits(row);
      if (!cleanText(r.Pilote) && !cleanText(r.Commentaires)) continue;
      try { await sauvegarderLigne(row); ok++; } catch { ko++; }
    }
    setIsSaving(false);
    setSaveMsg(ko === 0 ? `✅ ${ok} ligne(s) enregistrée(s)` : `⚠️ ${ok} OK / ${ko} erreur(s)`);
    setTimeout(() => setSaveMsg(''), 4000);
  }, []);

const filteredData = useMemo(() => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const limite = new Date(today);
  limite.setDate(limite.getDate() + 60);  // ← aujourd'hui + 60 jours

  return data
    .filter((r) => {
      const d = parseDate(r['Date de livraison prevue']);
      return d && d <= limite;            // ← exclut les dates > aujourd'hui + 60j
    })
    .filter((r) => !showOnlyManquants || Number(r.Rupture) !== 0)
    .filter((r) => !itemFilter     || r.Item?.toLowerCase().includes(itemFilter.toLowerCase()))
    .filter((r) => !commandeFilter || String(r['Numero de commande']).toLowerCase().includes(commandeFilter.toLowerCase()))
    .filter((r) => !clientFilter   || r.Client?.toLowerCase().includes(clientFilter.toLowerCase()));
}, [data, showOnlyManquants, itemFilter, commandeFilter, clientFilter]);

  const columns = useMemo(() =>
    data.length > 0 && data[0] != null ? Object.keys(data[0]).filter((col) => !HIDDEN.includes(col)) : [],
  [data]);

  const exportToExcel = () => {
    const cleanedData = filteredData.map(({ _index, ...row }) => {
      const r = getRowWithEdits({ _index, ...row });
      INT_COLS.forEach((col) => { if (r[col] != null) r[col] = Math.round(Number(r[col])); });
      const { _index: _i, ...rest } = r;
      return rest;
    });
    const ws = XLSX.utils.json_to_sheet(cleanedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Analyse');
    const parts = [];
    if (itemFilter)     parts.push(`Item-${itemFilter}`);
    if (clientFilter)   parts.push(`Client-${clientFilter}`);
    if (commandeFilter) parts.push(`Commande-${commandeFilter}`);
    saveAs(
      new Blob([XLSX.write(wb, { bookType: 'xlsx', type: 'array' })], { type: 'application/octet-stream' }),
      `analyse_rupture${parts.length ? '_' + parts.join('_') : ''}_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  // ── Styles partagés toolbar ──────────────────────────────────────────────
  const H = '32px';
  const inputStyle = (cfg) => ({
    height: H, width: cfg.inputWidth, fontSize: cfg.fontSize,
    padding: '0 8px', boxSizing: 'border-box',
    border: '1.5px solid #ddd', borderRadius: '7px',
    fontFamily: "'Segoe UI', sans-serif", outline: 'none', flexShrink: 0,
    color: '#2c3e50',
  });
  const labelStyle = (cfg) => ({
    width: cfg.labelWidth, fontSize: cfg.fontSize,
    color: '#6c757d', whiteSpace: 'nowrap', flexShrink: 0,
    textAlign: 'right', fontWeight: 600,
  });
  const Sep = () => (
    <span style={{ width: '1px', height: '20px', backgroundColor: '#e9ecef', flexShrink: 0, margin: '0 6px' }} />
  );

  // ── Render ───────────────────────────────────────────────────────────────
  return (
    <div style={{ padding: '28px 32px', fontFamily: "'Segoe UI', sans-serif", position: 'absolute', left: posX, top: posY, width, height, overflow: 'auto', boxSizing: 'border-box' }}>

      {/* ── Header ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: 700, color: '#2c3e50' }}>
          📊 Animation des ruptures
        </h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: '#888' }}>
          {[
            { key: 'row-red',    label: 'Rupture critique', border: '#e74c3c', text: '#c0392b' },
            { key: 'row-yellow', label: 'Rupture suivie',   border: '#f39c12', text: '#b7770d' },
            { key: 'row-green',  label: 'OK',               border: '#2ecc71', text: '#1a7a40' },
          ].map(({ key, label, border, text }) => (
            <span key={key} style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '3px 10px', borderRadius: '20px', background: ROW_COLORS[key], border: `1.5px solid ${border}`, color: text, fontWeight: 700, fontSize: '12px' }}>
              {label}
            </span>
          ))}
        </div>
      </div>

      {/* ── Barre de contrôles ── */}
      <div style={{
        background: 'white', borderRadius: '10px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
        padding: '10px 16px', marginBottom: '16px',
        display: 'flex', flexDirection: 'row', alignItems: 'center',
        flexWrap: 'nowrap', gap: '0px', overflowX: 'auto',
      }}>

        {/* Bouton Enregistrer tout */}
        {TOOLBAR_CONFIG.btnSave.show && (
          <>
            <button
              onClick={handleSaveAll}
              disabled={isSaving}
              style={{
                height: H, width: TOOLBAR_CONFIG.btnSave.width,
                marginLeft: TOOLBAR_CONFIG.btnSave.marginLeft,
                marginRight: TOOLBAR_CONFIG.btnSave.marginRight,
                fontSize: TOOLBAR_CONFIG.btnSave.fontSize,
                padding: '0 12px', flexShrink: 0,
                background: isSaving ? '#aaa' : 'linear-gradient(135deg, #3a7d44, #66bb6a)',
                color: 'white', border: 'none', borderRadius: '7px',
                cursor: isSaving ? 'not-allowed' : 'pointer',
                fontWeight: 700, whiteSpace: 'nowrap', boxSizing: 'border-box',
                fontFamily: "'Segoe UI', sans-serif",
              }}
            >
              {isSaving ? '⏳ Enregistrement…' : '💾 Enregistrer tout'}
            </button>
            {saveMsg && (
              <span style={{ fontSize: '13px', fontWeight: 700, whiteSpace: 'nowrap', flexShrink: 0, marginRight: '8px', color: saveMsg.startsWith('✅') ? '#2e7d32' : '#c62828' }}>
                {saveMsg}
              </span>
            )}
          </>
        )}

        <Sep />

        {/* Filtre Item */}
        {TOOLBAR_CONFIG.filterItem.show && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginLeft: TOOLBAR_CONFIG.filterItem.marginLeft, flexShrink: 0 }}>
            <span style={labelStyle(TOOLBAR_CONFIG.filterItem)}>Item</span>
            <input type="text" value={itemFilter} onChange={(e) => setItemFilter(e.target.value)} placeholder="Filtrer…" style={inputStyle(TOOLBAR_CONFIG.filterItem)} />
          </div>
        )}

        {/* Filtre Client */}
        {TOOLBAR_CONFIG.filterClient.show && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginLeft: TOOLBAR_CONFIG.filterClient.marginLeft, flexShrink: 0 }}>
            <span style={labelStyle(TOOLBAR_CONFIG.filterClient)}>Client</span>
            <input type="text" value={clientFilter} onChange={(e) => setClientFilter(e.target.value)} placeholder="Filtrer…" style={inputStyle(TOOLBAR_CONFIG.filterClient)} />
          </div>
        )}

        {/* Filtre N° commande */}
        {TOOLBAR_CONFIG.filterCommande.show && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginLeft: TOOLBAR_CONFIG.filterCommande.marginLeft, flexShrink: 0 }}>
            <span style={labelStyle(TOOLBAR_CONFIG.filterCommande)}>N° commande</span>
            <input type="text" value={commandeFilter} onChange={(e) => setCommandeFilter(e.target.value)} placeholder="Filtrer…" style={inputStyle(TOOLBAR_CONFIG.filterCommande)} />
          </div>
        )}

        <Sep />

        {/* Checkbox */}
        {TOOLBAR_CONFIG.checkbox.show && (
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', height: H, marginLeft: TOOLBAR_CONFIG.checkbox.marginLeft, fontSize: TOOLBAR_CONFIG.checkbox.fontSize, whiteSpace: 'nowrap', flexShrink: 0, cursor: 'pointer', color: '#2c3e50', fontWeight: 600 }}>
            <input type="checkbox" checked={showOnlyManquants} onChange={(e) => setShowOnlyManquants(e.target.checked)}
              style={{ width: '15px', height: '15px', margin: 0, cursor: 'pointer', accentColor: '#3498db' }} />
            Ruptures uniquement
          </label>
        )}

        <Sep />

        {/* Bouton Export Excel */}
     {TOOLBAR_CONFIG.btnExcel.show && (
  <button
    onClick={exportToExcel}
    style={{
      height: H,
      width: TOOLBAR_CONFIG.btnExcel.width,
      marginLeft: TOOLBAR_CONFIG.btnExcel.marginLeft,
      fontSize: '11px',
      padding: '0',
      flexShrink: 0,
      background: '#ffffff',
      color: '#04202d',
      border: '1px solid #d4c9b8',
      borderRadius: '6px',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      fontFamily: "'IBM Plex Mono', monospace",
      fontWeight: 600,
      letterSpacing: '0.07em',
      textTransform: 'uppercase',
    }}
  >
    Export Excel
  </button>
)}

        {/* Compteur lignes à droite */}
        <span style={{ marginLeft: 'auto', fontSize: '12px', color: '#888', whiteSpace: 'nowrap', flexShrink: 0, paddingLeft: '12px' }}>
          {filteredData.length} ligne{filteredData.length > 1 ? 's' : ''}
        </span>
      </div>

      {/* ── Tableau ── */}
      {columns.length === 0 ? (
        <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', padding: '32px', textAlign: 'center', color: '#aaa', fontSize: '14px' }}>
          Chargement des données…
        </div>
      ) : (
        <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
          <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '800px' }}>
            <table style={{ borderCollapse: 'collapse', width: 'auto', minWidth: '100%', fontSize: '12px' }}>
              <thead>
                <tr style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  {columns.map((col) => (
                    <th key={col} style={{
                      width: COLUMN_WIDTHS[col] || 100, minWidth: COLUMN_WIDTHS[col] || 100,
                      padding: '10px 8px',
                      background: '#f8f9fa',
                      borderBottom: '2px solid #e9ecef',
                      fontSize: '12px', fontWeight: 600, color: '#6c757d',
                      whiteSpace: 'normal', wordBreak: 'break-word',
                      textAlign: 'center', verticalAlign: 'middle',
                    }}>
                        {COLUMN_LABELS[col] || col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredData.map((row) => (
                  <AnimationRow key={row._index} row={row} columns={columns} utilisateurs={utilisateurs} editsRef={editsRef} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Animation;